import * as fromDatatype from '../datatype-library/index';

export interface bl_applet_setting_filter_fi_item_category_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  guid_label_hdr: fromDatatype.GuidDataFieldInterface;
  header_table: fromDatatype.VarcharDatatypeInterface;
  line_table: fromDatatype.VarcharDatatypeInterface;
  guid_hdr: fromDatatype.GuidDataFieldInterface;
  guid_line: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  guid_branch: fromDatatype.GuidDataFieldInterface;
  category_json: fromDatatype.JsonDatatypeInterface;
  level_value: fromDatatype.IntegerDatatypeInterface;
  exclude_category_json: fromDatatype.JsonDatatypeInterface;
}

export class bl_applet_setting_filter_fi_item_category_link_RowClass
  implements bl_applet_setting_filter_fi_item_category_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  guid_label_hdr: fromDatatype.GuidDataFieldInterface;
  header_table: fromDatatype.VarcharDatatypeInterface;
  line_table: fromDatatype.VarcharDatatypeInterface;
  guid_hdr: fromDatatype.GuidDataFieldInterface;
  guid_line: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  guid_branch: fromDatatype.GuidDataFieldInterface;
  category_json: fromDatatype.JsonDatatypeInterface;
  level_value: fromDatatype.IntegerDatatypeInterface;
  exclude_category_json: fromDatatype.JsonDatatypeInterface;
}